import Select from "react-select";

export interface SimpleSelectOption {
  value: string;
  label: string;
}

interface SimpleSelectProps {
  value?: string | null;
  options: SimpleSelectOption[];
  onChange: (value: string | null) => void;
  placeholder?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
}

/**
 * Liste déroulante alignée sur les autres champs react-select de l'app.
 * Le style (repos, focus, survol) vient de .react-select__* dans global.scss.
 */
export default function SimpleSelect({
  value,
  options,
  onChange,
  placeholder,
  isClearable = false,
  isDisabled = false,
}: SimpleSelectProps) {
  const selected = options.find((option) => option.value === value) ?? null;

  return (
    <Select
      className="w-full"
      classNamePrefix="react-select"
      value={selected}
      options={options}
      placeholder={placeholder}
      isClearable={isClearable}
      isDisabled={isDisabled}
      onChange={(option) => onChange(option ? option.value : null)}
    />
  );
}
